import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import lifecycle from 'recompose/lifecycle';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import ShippingCountry from './ShippingCountry';

const enhance = compose(
  withProps(props => ({
    countries: props.eagleCountries.map(eagleCountry => {
      const prismicCountry = props.prismicCountries.find(country => country.code === eagleCountry);
      return {
        value: eagleCountry,
        label: get(prismicCountry, 'name', eagleCountry),
      };
    }),
    states: props.states.map(state => ({
      value: state.abbr,
      label: state.name,
    })),
  })),
  lifecycle({
    componentDidUpdate(prevProps) {
      const nextStates = this.props.states;
      const shouldUpdate = !isEqual(prevProps.states, nextStates);
      if (shouldUpdate) {
        prevProps.setFieldValue(
          'stateAbbr', nextStates.length > 0 ? nextStates[0].value : null
        );
      }
    },
  }),
);

export default enhance(ShippingCountry);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Shipping/ShippingCountry/index.js